import { cn } from '@utils/cn';
import React from 'react';

export type AutoSaveState = 'idle' | 'saving' | 'saved' | 'error';

interface AutoSaveIndicatorProps {
  state: AutoSaveState;
  lastSavedAt?: Date | null;
  errorMessage?: string;
  className?: string;
}

const formatTime = (date: Date): string => {
  return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
};

export const AutoSaveIndicator: React.FC<AutoSaveIndicatorProps> = ({
  state,
  lastSavedAt,
  errorMessage,
  className = '',
}) => {
  const baseClasses = 'inline-flex items-center gap-2 text-sm';

  if (state === 'saving') {
    return (
      <span className={cn(baseClasses, 'text-blue-600', className)}>
        <span className="w-2 h-2 rounded-full bg-blue-500 animate-pulse" />
        Saving…
      </span>
    );
  }

  if (state === 'error') {
    return (
      <span className={cn(baseClasses, 'text-red-600', className)} title={errorMessage}>
        <span className="w-2 h-2 rounded-full bg-red-500" />
        {errorMessage || 'Failed to save'}
      </span>
    );
  }

  if (state === 'saved' && lastSavedAt) {
    return (
      <span className={cn(baseClasses, 'text-gray-500', className)}>
        <span className="w-2 h-2 rounded-full bg-emerald-500" />
        Saved at {formatTime(lastSavedAt)}
      </span>
    );
  }

  return (
    <span className={cn(baseClasses, 'text-gray-400', className)}>
      <span className="w-2 h-2 rounded-full bg-gray-300" />
      Idle
    </span>
  );
};
